export default {"src":"/_next/static/image/src/images/onboarding/list.33b8710d7bf875dd8352813016d370a7.svg","height":70,"width":86};